export default __webpack_public_path__ + "static/media/the_fork.cc4b954e.png";